export const MESSAGE_TEMPLATES = [
  {
    id: 'initial_confirmation',
    name: 'Confirmation initiale',
    content: 'Bonjour, nous avons bien reçu votre commande n°[NUMERO]. Pour confirmer la livraison, merci de répondre par OUI. Pour modifier l\'adresse ou annuler, répondez par NON.'
  },
  {
    id: 'reminder',
    name: 'Rappel',
    content: 'Rappel : Nous n\'avons pas reçu votre confirmation pour la commande n°[NUMERO]. Merci de nous confirmer si vous souhaitez maintenir la livraison.'
  },
  {
    id: 'delivery_confirmation',
    name: 'Confirmation de livraison',
    content: 'Votre commande n°[NUMERO] sera livrée demain. L\'adresse de livraison est : [ADRESSE]. Si c\'est correct, répondez OUI.'
  },
  {
    id: 'confirmation',
    name: 'Confirmation de commande',
    content: 'Bonjour, nous avons bien reçu votre commande n°[NUMERO]. Pouvez-vous confirmer que vous souhaitez toujours être livré à cette adresse ? Merci !'
  },
  {
    id: 'reminder_new',
    name: 'Rappel',
    content: 'Bonjour, nous n\'avons pas reçu de confirmation pour votre commande n°[NUMERO]. Souhaitez-vous toujours être livré ? Merci de nous le confirmer.'
  },
  {
    id: 'shipping',
    name: 'Information livraison',
    content: 'Votre commande n°[NUMERO] sera livrée demain. Merci de votre confiance !'
  },
  {
    id: 'cod_confirmation',
    name: 'Confirmation Paiement à la Livraison',
    content: 'Bonjour, votre commande n°[NUMERO] est prête pour la livraison. Montant à payer à la livraison : [MONTANT] DA. Merci de préparer le montant exact en espèces.'
  },
  {
    id: 'cod_reminder',
    name: 'Rappel - Paiement à la Livraison',
    content: 'Rappel : Le livreur arrivera bientôt avec votre commande n°[NUMERO]. Montant à préparer : [MONTANT] DA. Merci de préparer le montant exact.'
  },
  {
    id: 'cod_morning',
    name: 'Livraison COD - Matin',
    content: 'Bonjour, le livreur passera ce matin pour votre commande n°[NUMERO]. Montant à préparer : [MONTANT] DA. En cas d\'absence, merci de nous contacter.'
  },
  {
    id: 'cod_afternoon',
    name: 'Livraison COD - Après-midi',
    content: 'Bonjour, le livreur passera cet après-midi pour votre commande n°[NUMERO]. Montant à préparer : [MONTANT] DA. En cas d\'absence, merci de nous contacter.'
  },
  {
    id: 'cod_failed_delivery',
    name: 'Échec Livraison COD',
    content: 'Le livreur est passé pour votre commande n°[NUMERO] mais n\'a pas pu vous livrer. Montant à préparer pour la prochaine livraison : [MONTANT] DA. Contactez-nous pour reprogrammer.'
  },
  {
    id: 'cod_success',
    name: 'Confirmation Paiement COD',
    content: 'Nous confirmons avoir reçu votre paiement de [MONTANT] DA pour la commande n°[NUMERO]. Merci de votre confiance !'
  }
];
